// eslint-disable-next-line
import React, { useState } from "react";
import PreviewModal from "../PreviewModal";
import { cld } from "../../shared/utils";

// Resolves a value that is either a Cloudinary public ID or a legacy full URL.
// - If it starts with "http" it's already a usable URL (cached old data).
// - Otherwise treat it as a Cloudinary public ID and build the CDN URL.
const resolveImg = (val, width) => {
  if (!val) return "";
  if (val.startsWith("http")) return val;
  return cld(val, width);
};

const Certificate = ({
  imageId,
  image, // legacy field still present in 24-hour localStorage cache
  title,
  platform,
  logo,
  issuedOn,
  credentialId,
  link,
  description,
  modelListItems,
  toggleState,
  index,
  toggleTab,
}) => {
  const [imageError, setImageError] = useState(false);

  // Prefer the new Cloudinary public ID; fall back to legacy cached URL.
  const imgSrc = resolveImg(imageId || image, 414);
  const logoSrc = resolveImg(logo, 160);

  return (
    <>
      <div
        className="certificates__image"
        style={{
          background: imageError
            ? "color-mix(in srgb, var(--title-color) 15%, transparent)"
            : "",
        }}
        onClick={() => toggleTab(index)}
      >
        {imageError && (
          <div className="image-error__others">
            <i className="uil uil-image-slash"></i>
          </div>
        )}
        <img
          src={imgSrc}
          alt={title}
          title={title}
          width="310"
          height="240"
          loading="lazy"
          decoding="async"
          className="certificates__image"
          onError={() => setImageError(true)}
          style={{ display: imageError ? "none" : "block" }}
        />
      </div>
      <span className="certificates__button" onClick={() => toggleTab(index)}>
        View More
        <i className="uil uil-arrow-right certificates__button-icon"></i>
      </span>

      {/* Using the PreviewModal Component */}
      <PreviewModal
        isOpen={toggleState === index}
        onClose={() => toggleTab(0)}
        image={imgSrc}
        title={title}
        platform={platform}
        logo={logoSrc}
        issuedOn={issuedOn}
        credentialId={credentialId}
        link={link}
        description={description}
        modelListItems={modelListItems}
      />
    </>
  );
};

export default Certificate;
